/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AppointmentCard from 'DesignSystem/AppointmentCard/index'
import LoadingBar from 'DesignSystem/LoadingBar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Appointments/TabContent/Content/AppointmentsList/Loading"
  
}) {
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="Loading.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<AppointmentCard
  viewPath={`${viewPath}/AppointmentCard`}
 variant="skeleton"
>
{childProps => (
<LoadingBar
{...childProps}
  viewPath={`${viewPath}/LoadingBar`}
 height="100%"
 width={400}
 delay={0}
 backgroundColorForeground={dtColorsNeutral100}
 backgroundColorBackground={dtColorsWhite}
/>
)}
</AppointmentCard>
<AppointmentCard
  viewPath={`${viewPath}/AppointmentCard`}
 variant="skeleton"
>
{childProps => (
<LoadingBar
{...childProps}
  viewPath={`${viewPath}/LoadingBar`}
 height="100%"
 width={400}
 delay={50}
 backgroundColorForeground={dtColorsNeutral100}
 backgroundColorBackground={dtColorsWhite}
/>
)}
</AppointmentCard>
<AppointmentCard
  viewPath={`${viewPath}/AppointmentCard`}
 variant="skeleton"
>
{childProps => (
<LoadingBar
{...childProps}
  viewPath={`${viewPath}/LoadingBar`}
 height="100%"
 width={400}
 delay={100}
 backgroundColorForeground={dtColorsNeutral100}
 backgroundColorBackground={dtColorsWhite}
/>
)}
</AppointmentCard>
</div>
{children}
</React.Fragment>)
}